import { motion } from "framer-motion";

const PIPS: Record<number, number[]> = { 1: [4], 2: [0, 8], 3: [0, 4, 8], 4: [0, 2, 6, 8], 5: [0, 2, 4, 6, 8], 6: [0, 2, 3, 5, 6, 8] };
const TONES = ["bg-white", "bg-white", "bg-white"];

function Die({ value, index, fast }: { value: number; index: number; fast: boolean }) {
  return (
    <motion.div
      className={`grid h-20 w-20 grid-cols-3 grid-rows-3 gap-1 rounded-2xl border-[3px] border-[#d9d4cc] p-2 shadow-[inset_-6px_-6px_0_rgba(0,0,0,0.08),0_8px_20px_rgba(0,0,0,0.4)] sm:h-24 sm:w-24 ${TONES[index % 3]}`}
      initial={fast ? false : { rotate: -540, scale: 0.3, x: -80 }}
      animate={{ rotate: 0, scale: 1, x: 0 }}
      transition={{ duration: 0.75, delay: index * 0.07, ease: [0.2, 0.9, 0.3, 1.15] }}
    >
      {Array.from({ length: 9 }).map((_, i) => (
        <span key={i} className={`m-auto h-3.5 w-3.5 rounded-full sm:h-4 sm:w-4 ${PIPS[value].includes(i) ? "bg-[#E11D48] shadow-[inset_0_2px_2px_rgba(0,0,0,0.35)]" : ""}`} />
      ))}
    </motion.div>
  );
}

export function DiceRoll({ values, fast }: { values: number[]; fast: boolean }) {
  return (
    <div className="flex items-center justify-center gap-3" data-testid="dice-roll-anim">
      {values.map((v, i) => <Die key={i} value={v} index={i} fast={fast} />)}
    </div>
  );
}
